/**
 * TECYMDV-1895 / dacordero@personalsoft.com.co / 2021-07-02 / Obligatoriedad de campos pantalla clientes por producto
 */
 export class ConstantesFormularioCliente {

  public static readonly CAMPO_TELEFONO_LONGITUD: number = 10;
  public static readonly LITERAL_SI: string = 'S';
  public static readonly LITERAL_NO: string = 'N';
  public static readonly TITULO_CIUDAD: string = 'Ciudad';

  public static readonly SUFIJO_RADIOCONTROL = 'RadioCtrl';
  public static readonly SUFIJO_DIRECCIONCONTROL = 'DireccionCtrl';
  public static readonly SUFIJO_TELEFONOCONTROL = 'TelefonoCtrl';
  public static readonly SUFIJO_CIUDADCONTROL = 'CiudadCtrl';

  public static readonly MOSTRAR_BLOQUE_DIRECCION = 'bloqueDireccion';
  public static readonly DIRECCIONES_PREFIJO =
    ConstantesFormularioCliente.MOSTRAR_BLOQUE_DIRECCION + '_';
  public static readonly MAX_SUFIJO_CARACTERES = 2;
  public static readonly DIRECCION_NECESARIA = "direccionNecesaria";
  public readonly MOSTRAR_BLOQUE_DIRECCION_1 =
    ConstantesFormularioCliente.DIRECCIONES_PREFIJO + 1;

  public readonly MOSTRAR_BLOQUE_DIRECCION_2 =
    ConstantesFormularioCliente.DIRECCIONES_PREFIJO + 2;

  public readonly MOSTRAR_BLOQUE_DIRECCION_3 =
    ConstantesFormularioCliente.DIRECCIONES_PREFIJO + 3;

  // Nombres de los bloques de campos.

  public readonly MOSTRAR_CAMPO_DOCUMENTO_TIPO = 'tipoDocumentoControl';
  public readonly MOSTRAR_CAMPO_DOCUMENTO_VALOR = 'documentControl';

  public readonly MOSTRAR_CAMPO_NOMBRE_PRIMERO_RS = 'primerNombreControl';
  public readonly MOSTRAR_CAMPO_NOMBRE_SEGUNDO = 'segundoNombreControl';

  public readonly MOSTRAR_CAMPO_APELLIDO_PRIMERO = 'primerApellidoControl';
  public readonly MOSTRAR_CAMPO_APELLIDO_SEGUNDO = 'segundoApellidoControl';

  public readonly MOSTRAR_CAMPO_FECHA_NACIMIENTO = 'fechaNacimientoControl';

  public readonly MOSTRAR_CAMPO_SEXO = 'sexoControl';

  public readonly MOSTRAR_CAMPO_CELULAR = 'celularControl';
  public readonly MOSTRAR_CAMPO_EMAIL_TIPO = 'tipoCorreoEleControl';

  public readonly MOSTRAR_CAMPO_EMAIL = 'emailControl';

  public readonly MOSTRAR_BLOQUE_OCUPACION = 'tipoActividadControl';

  public readonly SUFIJO_DIRECCION = 'DireccionCtrl';
  public readonly SUFIJO_TELEFONO = 'TelefonoCtrl';
  public readonly SUFIJO_CIUDAD = 'CiudadCtrl';

}



// WEBPACK FOOTER //
// ./src/app/components/cliente/registro-cliente/constantes-formulario-clientes.ts